import { inject, Injectable } from '@angular/core';
import { OUTLAW_COOKIES, PassportService, StorageService, TargetUrl } from '@outlaw/core';
import { GuestAuthOptions, MajiAppAuthOptions } from '../../interfaces';
import { CommunityNavigationService } from '../navigation/community-navigation.service';
import { DialogManagerService } from '../dialog/dialog-manager.service';
import { FeatureFlagService } from '../util/feature-flag.service';
import { CommunityMobileEventsService } from '../util/mobile-events.service';

@Injectable({
  providedIn: 'root',
})
export class GuestAuthService {
  #storageService = inject(StorageService);
  #mobileEventsService = inject(CommunityMobileEventsService);
  #featureFlagService = inject(FeatureFlagService);
  #dialogManagerService = inject(DialogManagerService);
  #passportService = inject(PassportService);
  #navigationService = inject(CommunityNavigationService);

  handleGuestAuth(options: GuestAuthOptions = {}): void {
    const { filmId, postId, onCommunityInApp, usePassportRedirect, returnSubscribePage } = options;

    if (this.#featureFlagService.isCommunityInApp()) {
      onCommunityInApp?.();
      return;
    }

    if (this.#mobileEventsService.isWebView) {
      this.#mobileEventsService.openAuth();
      return;
    }

    if (usePassportRedirect) {
      this.handlePassportRedirect(filmId, returnSubscribePage);
      return;
    }

    this.handleMajiAppAuth({ filmId, postId });
  }

  private handleMajiAppAuth({ filmId, postId }: Partial<MajiAppAuthOptions>): void {
    this.#dialogManagerService.openGuestLoginDialog();

    if (filmId) {
      this.#storageService.set(OUTLAW_COOKIES.return_film_id, filmId);
    }

    if (postId) {
      this.#storageService.set(OUTLAW_COOKIES.return_post_id, postId);
    }
  }

  private handlePassportRedirect(filmId?: string, returnSubscribePage?: string): void {
    if (filmId) {
      this.#storageService.set(OUTLAW_COOKIES.return_film_id, filmId);
    }

    if (returnSubscribePage) {
      this.#storageService.set(OUTLAW_COOKIES.return_subscribe_page, returnSubscribePage);
    }

    const link = this.#passportService.getLoginLink();
    this.#navigationService.openExternalUrl(link, TargetUrl.sameWindow);
  }
}
